import axios from 'axios';
import config from '../config';

const API_BASE_URL = `${config.serverUrl}/users/mobSign`;

export const initiateMobileSignature = async (msisdn) => {
  const response = await axios.post(`${API_BASE_URL}/initiate/${msisdn}`, {});
  return response.data;
};

export const confirmMobileSignature = async (transactionId) => {
  const response = await axios.post(
    `${API_BASE_URL}/confirm/${transactionId}`,
    {},
    { timeout: 135000 }
  );
  return response.data;
};

export const checkMobileSignatureStatus = async (transactionId) => {
  const response = await axios.get(`${API_BASE_URL}/status/${transactionId}`);
  return response.data;
};

export const initiateSignupMobileSignature = async (msisdn) => {
  const response = await axios.post(
    `${config.serverUrl}/users/${msisdn}/register/mobileSignature`,
    {}
  );
  return response.data;
};

export const confirmSignupMobileSignature = async (transactionId) => {
  const response = await axios.post(
    `${config.serverUrl}/users/register/mobileSignature/confirm/${transactionId}`,
    {},
    { timeout: 135000 }
  );
  return response.data;
};
